__turbopack_context__.v({
  "headline": "headline-component-module-scss-module__rx9yoa__headline",
  "headline--full-width": "headline-component-module-scss-module__rx9yoa__headline--full-width",
  "headline__headline": "headline-component-module-scss-module__rx9yoa__headline__headline",
  "headline__headline-tag": "headline-component-module-scss-module__rx9yoa__headline__headline-tag",
  "headline__icon": "headline-component-module-scss-module__rx9yoa__headline__icon",
  "headline__sub-headline": "headline-component-module-scss-module__rx9yoa__headline__sub-headline",
  "headline__sub-headline--footer": "headline-component-module-scss-module__rx9yoa__headline__sub-headline--footer",
});
